"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPin(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M13.632.54a.766.766 0 011.273-.315l8.87 8.873a.766.766 0 01-.314 1.273 7.893 7.893 0 01-4.47.056l-.146-.044-3.89 3.892.054.12c.9 2.118 1.062 4.481.456 6.693l-.097.331a.766.766 0 01-1.273.314l-5.373-5.371-7.415 7.414a.766.766 0 01-1.157-.998l.074-.086L7.64 15.28 2.267 9.907a.766.766 0 01.215-1.235l.099-.038a10.228 10.228 0 017.02.356l.12.053 3.895-3.894-.055-.186a7.895 7.895 0 01-.025-4.09zm1.204 1.783l-.012.133a6.37 6.37 0 00.386 2.634.766.766 0 01-.177.809l-4.608 4.607a.766.766 0 01-.887.142A8.725 8.725 0 004.341 9.8l-.013.001 9.872 9.87.044-.344a8.716 8.716 0 00-.746-4.562l-.147-.305a.766.766 0 01.141-.888l4.604-4.606a.766.766 0 01.81-.176 6.373 6.373 0 002.637.388l.133-.013-6.84-6.842z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgPin;
exports.default = _default;